<!-- eslint-disable max-len -->
<template>
    <div class="container d-flex  align-items-center text-center flex-column">
        <div class="mt-3">
            <h1>404</h1>
            <p>Page not found :(</p>
        </div>
        <img src="../assets/404/404.gif" alt="404" class="img-fluid rounded shadow-lg" style="height: 50vh; width: 50vh;" />

    </div>
</template>
<script>

/**
    *Page for displaying not found recource
*/

export default {
  name: 'NotFound',
};
</script>

